import PropTypes from 'prop-types';
import './text-animate.css';

const TextAnimate = ({ children, animation = 'blurInUp', by = 'character', duration = 0.6 }) => {
  const text = typeof children === 'string' ? children : String(children ?? '');
  const units = by === 'word' ? text.split(/(\s+)/) : Array.from(text);
  const count = units.length || 1;
  // Distribute total duration across units as staggered delays
  const delayStep = Math.max(0.01, duration / count);

  return (
    <span className={`ta ta-${animation}`} aria-label={text}>
      {units.map((u, i) => (
        <span
          key={i}
          className="ta-unit"
          style={{ animationDelay: `${i * delayStep}s` }}
        >
          {u}
        </span>
      ))}
    </span>
  );
};

TextAnimate.propTypes = {
  children: PropTypes.node,
  animation: PropTypes.oneOf(['blurInUp']),
  by: PropTypes.oneOf(['character', 'word']),
  duration: PropTypes.number,
};

export default TextAnimate;
